import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initGalleryScroll() {
  const gallery = document.querySelector('.cantine-gallery-scroll');
  if (!gallery) return;

  // Calcola la larghezza totale del contenuto della gallery
  const galleryItems = gallery.querySelectorAll('.cantine-gallery-item');
  let totalWidth = 0;
  
  galleryItems.forEach(item => {
    totalWidth += item.offsetWidth;
  });

  // Imposta la larghezza del container per permettere lo scroll orizzontale
  gallery.style.width = `${totalWidth}px`;

  const container = gallery.parentElement;
  const totalScroll = gallery.scrollWidth - container.clientWidth;
  
  gsap.to(gallery, {
    x: -totalScroll,
    ease: "none",
    scrollTrigger: {
      trigger: container,
      start: "top top",                 // inizia quando la top del container arriva alla top del viewport
      end: () => `+=${totalScroll}`,       // continua per la lunghezza dello scroll orizzontale
      scrub: 1,                           // collega lo scroll verticale a quello orizzontale
      pin: true,                          // blocca la sezione durante lo scroll
      pinSpacing: true,                   // mantiene lo spazio per il pin
      invalidateOnRefresh: true,          // ricalcola su resize
    }
  });
}